import { useDispatch, useSelector } from "react-redux";
import {
  GetDataFromServer,
  GetDataListFromServer,
  UpdateDataWithUserIdOnServer,
  UpdateSingleDataOnServer,
} from "../../lib/api";
import {
  Button,
  Col,
  DatePicker,
  Drawer,
  Row,
  Select,
  Space,
  Table,
  Tag,
  Input,
  Typography,
  Popconfirm,
  Tabs,
} from "antd";
import {
  AGENT_LIST,
  GAME_WALLET_TO_MAIN_WALLET,
  USER_GET_LIST,
  USER_TRANSACTION_LIST,
} from "../../lib/config";
import { moneyFormat, queryHandler } from "../../lib/global_functions";
import toast from "react-hot-toast";
import {
  clearUserId,
  resetTransactionNoti,
  setState,
  updateUserId,
} from "../../redux/user";
import { isValidElement, useEffect, useState } from "react";
import { QUERY_USER, QUERY_USER_TRANSACTION_ALL } from "../../lib/query_obj";
import moment from "moment-timezone";
import ExpandableContent from "./expandable_content";
import ConfirmForm from "../user/detail/confirm_form";
import dayjs from "dayjs";
import UserDetail from "../user/detail";
import { ArrowRightOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { Option } = Select;
export default function Transaction() {
  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);

  const [detail, setDetail] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [confirmData, setConfirmData] = useState(false);
  const [rejectData, setRejectData] = useState(false);

  const [detailForm, setDetailForm] = useState(false);
  const [selectedUser, setSelectedUser] = useState(false);
  const [tabKey, setTabKey] = useState("not_finish");

  const [pagin, setPagin] = useState({
    page_number: 1,
    per_page: 10,
    total: 0,
  });
  const [filter, setFilter] = useState({
    user_code: "",
    type: "",
    start_date: "",
    end_date: "",
  });

  async function getRefreshDataList() {
    await GetDataFromServer(AGENT_LIST, user.access_token)
      .then((res) => {
        dispatch(
          setState({
            ...user,
            points: res.data.points,
            total_deposit_points: res.data.total_deposit_points,
            total_withdraw_points: res.data.total_withdraw_points,
          })
        );
      })
      .catch((error) => {
        toast.error(error?.response.data || "Connection Error");
      });
  }

  async function getDataList(
    page_number,
    per_page,
    updateFilter,
    currentTabKey
  ) {
    const currentFilter = updateFilter || filter;
    const isFinishKey = currentTabKey || tabKey;

    const queryFilter = {
      ...currentFilter,
      start_date: currentFilter.start_date
        ? moment
            .tz(currentFilter.start_date, "Asia/Yangon")
            .startOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        : "",
      end_date: currentFilter.end_date
        ? moment
            .tz(currentFilter.end_date, "Asia/Yangon")
            .endOf("day")
            .utc()
            .format("YYYY-MM-DD HH:mm:ss")
        : "",
      is_finish: isFinishKey === "finish" ? "TRUE" : "FALSE",
    };
    console.log("query filter...", queryFilter);
    setLoading(true);
    await GetDataListFromServer(
      USER_TRANSACTION_LIST,
      queryHandler(queryFilter, QUERY_USER_TRANSACTION_ALL, {
        page_number,
        per_page,
      }),
      user.access_token
    )
      .then(({ data: { data: res, total } }) => {
        setLoading(false);
        updateFilter && setFilter(updateFilter);
        setPagin((prev) => ({ ...prev, page_number, per_page, total }));
        setList(res);
        dispatch(resetTransactionNoti());
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.error || "Connection Error");
      });
  }

  async function handleDetail(userCode) {
    setLoading(true);

    await GetDataListFromServer(
      USER_GET_LIST,
      queryHandler({ code: userCode }, QUERY_USER, {
        page_number: 1,
        per_page: 10,
      }),
      user.access_token
    )
      .then((res) => {
        setLoading(false);
        if (res.data.data.length > 0) {
          setSelectedUser(res.data.data[0]);
          setDetailForm(true);
        } else {
          toast.error("User not found");
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error);
      });
  }

  useEffect(() => {
    getDataList(pagin.page_number, pagin.per_page);
    getRefreshDataList();
  }, []);

  useEffect(() => {
    if ((user.playing_user_ids || user.user_play_game_id) && list.length > 0) {
      const updatedList = list.map((item) => {
        if (user.playing_user_ids.includes(item.user_id)) {
          return { ...item, user_current_point: "0", play_game: true };
        }
        if (item.user_id === user.user_play_game_id) {
          return {
            ...item,
            user_current_point: user.user_points,
            play_game: user.play_game,
          };
        }
        return item;
      });

      setList(updatedList);
    }
  }, [user.playing_user_ids, user.user_play_game_id]);

  useEffect(() => {
    if (user.transaction_noti) {
      getDataList(pagin.page_number, pagin.per_page);
    }
  }, [user.transaction_noti]);

  function confirmHandler(record, type) {
    setDetail(record);
    setShowForm(true);
    if (type === "accept") {
      setConfirmData(record);
    } else {
      setRejectData(record);
    }
  }

  function closeDrawer() {
    setShowForm(false);
    setDetail(false);
    setConfirmData(false);
    setRejectData(false);
  }

  const columns = [
    {
      title: "Transaction Type",
      dataIndex: "type",
      render: (record) => {
        return (
          <Text style={{ color: record === "DEPOSIT" ? "lime" : "orange" }}>
            {record}
          </Text>
        );
      },
    },

    {
      title: "User Code",
      dataIndex: "user_code",
      render: (record) => {
        return <Text>{record ? record : "-"}</Text>;
      },
    },

    {
      title: "User Current Points",
      dataIndex: "user_current_point",
      render: (record) => {
        return <span>{moneyFormat(record || 0)}</span>;
      },
    },
    {
      title: "Amount",
      dataIndex: "amount",
      render: (amount) => {
        return <span>{moneyFormat(amount || 0)}</span>;
      },
    },

    {
      title: "Is Approved?",
      dataIndex: "is_approved",
      render: (_, record) => {
        const { is_finish, is_approved } = record;
        let status, color, textColor;

        switch (true) {
          case !is_finish:
            status = "Pending";
            color = "gold";
            textColor = "gold";
            break;
          case is_approved:
            status = "Accept";
            color = "lime";
            textColor = "lime";
            break;
          default:
            status = "Reject";
            color = "magenta";
            textColor = "magenta";
        }

        return (
          <Tag color={color}>
            <Text style={{ color: textColor }}>{status}</Text>
          </Tag>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "updated_at",
      render: (record) => {
        return moment
          .utc(record)
          .tz("Asia/Yangon")
          .format("DD-MM-YYYY, HH:mm:ss");
      },
    },
    {
      title: "Now Playing?",
      dataIndex: "play_game",
      render: (_, record) => {
        return (
          <Tag color={record.play_game ? "lime" : "red"}>
            <Text style={{ color: record.play_game ? "lime" : "red" }}>
              {record.play_game ? "Yes" : "No"}
            </Text>
          </Tag>
        );
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: "100px",
      render: (_, record) => (
        <Row justify="end">
          <Space>
            {user.permissions.includes("AGENT_CREATE_USER_TRANSACTION") &&
              !record.is_finish && (
                <Button
                  size={user.ui_size}
                  type="primary"
                  onClick={() => confirmHandler(record, "accept")}
                >
                  Accept
                </Button>
              )}

            {user.permissions.includes("AGENT_CREATE_USER_TRANSACTION") &&
              !record.is_finish && (
                <Button
                  size={user.ui_size}
                  type="primary"
                  onClick={() => confirmHandler(record, "reject")}
                >
                  Reject
                </Button>
              )}

            {user.permissions.includes("AGENT_CREATE_USER_TRANSACTION") &&
              tabKey === "not_finish" && (
                <Popconfirm
                  title="Are you sure to change game wallet to main wallet?"
                  okText="Yes"
                  cancelText="No"
                  onConfirm={() => updateWalletHandler(record.user_id)}
                >
                  <Button
                    disabled={record.play_game && !record.is_finish}
                    size={user.ui_size}
                    type="primary"
                  >
                    Game To Main Wallet
                  </Button>
                </Popconfirm>
              )}

            <Button
              onClick={() => handleDetail(record.user_code)}
              size={user.ui_size}
              type="primary"
            >
              User Detail
            </Button>
          </Space>
        </Row>
      ),
    },
  ];

  const finishColumn = [
    {
      title: "Transaction Type",
      dataIndex: "type",
      align:"center",
      render: (record) => {
        return (
          <Text style={{ color: record === "DEPOSIT" ? "lime" : "orange" }}>
            {record}
          </Text>
        );
      },
    },
    {
      title: "User Code",
      dataIndex: "user_code",
      align:"center",
      render: (record) => {
        return <Text>{record ? record : "-"}</Text>;
      },
    },
    {
      title:
        tabKey === "finish"
          ? "Agent Transaction Points"
          : "User Current Points",

      align: "center",
      width:"400px",
      render: (_, record) => {
        const isReject = !record.is_approved;
        return isReject ? (
          <Row align={"middle"} justify="center">
            - - -
          </Row>
        ) : (
          <Row align={"middle"} justify="center">
            <Tag color="warning" style={{ minWidth: '160px', textAlign: 'center' }}>
              <Text>{moneyFormat(record.agent_old_points || 0)}</Text>
            </Tag>

            <ArrowRightOutlined />

            <Tag color="warning" style={{ marginLeft: "10px", minWidth: '160px', textAlign: 'center' }} >
              <Text>{moneyFormat(record.agent_new_points || 0)}</Text>
            </Tag>
          </Row>
        );
      },
    },
    {
      title: "User Transaction Points",
      dataIndex: "amount",
      align: "center",
      width:"400px",
      render: (_, record) => {
        const isReject = !record.is_approved;
        return (
          <Row align="middle" justify="center" gutter={[0, 4]}>
            <Col>
              <span>
                {moneyFormat(record.amount)}
                <Text style={{ color: "green" }}> ({record.currency})</Text>
              </span>
            </Col>
            <Col span={24}></Col>
            <Col>
              {isReject ? (
                <Row align={"middle"} justify="center">
                  - - -
                </Row>
              ) : (
                <Row align={"middle"} justify="center">
                  <Tag color="lime" style={{ minWidth: '160px', textAlign: 'center' }}>
                    <Text>
                      {moneyFormat(record.old_points || 0)}
                    </Text>
                  </Tag>

                  <ArrowRightOutlined />

                  <Tag color="lime" style={{ marginLeft: "10px", minWidth: '160px', textAlign: 'center'  }}>
                    <Text>
                      {moneyFormat(record.new_points || 0)}
                    </Text>
                  </Tag>
                </Row>
              )}
            </Col>
          </Row>
        );
      },
    },

    {
      title: "Is Approved?",
      dataIndex: "is_approved",
      align:"center",
      render: (_, record) => {
        const { is_finish, is_approved } = record;
        let status, color, textColor;

        switch (true) {
          case !is_finish:
            status = "Pending";
            color = "gold";
            textColor = "gold";
            break;
          case is_approved:
            status = "Accept";
            color = "lime";
            textColor = "lime";
            break;
          default:
            status = "Reject";
            color = "magenta";
            textColor = "magenta";
        }

        return (
          <Tag color={color}>
            <Text style={{ color: textColor }}>{status}</Text>
          </Tag>
        );
      },
    },
    {
      title: "Date",
      dataIndex: "updated_at",
      align:"center",
      render: (record) => {
        return moment
          .utc(record)
          .tz("Asia/Yangon")
          .format("DD-MM-YYYY, HH:mm:ss");
      },
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: "100px",
      align:"center",
      render: (_, record) => (
        <Row justify="end">
          <Space>
            <Button
              onClick={() => handleDetail(record.user_code)}
              size={user.ui_size}
              type="primary"
            >
              User Detail
            </Button>
          </Space>
        </Row>
      ),
    },
  ];

  async function updateWalletHandler(id) {
    setLoading(true);
    await UpdateSingleDataOnServer(
      GAME_WALLET_TO_MAIN_WALLET,
      id,
      user.access_token,
      user.csrf_token
    )
      .then(() => {
        setLoading(false);
        toast.success("Updated game wallet to main wallet successfully");
      })
      .catch(() => {
        setLoading(false);
        toast.error("Update Failed");
      });
  }

  function clearFilter() {
    getDataList(pagin.page_number, pagin.per_page, {
      ...filter,
      user_code: "",
      type: "",
      start_date: "",
      end_date: "",
    });
  }

  return (
    <>
      <Row gutter={[16, 24]} justify="end">
        <Col span={24}>
          <Tabs
            activeKey={tabKey}
            tabBarExtraContent={
              <Text style={{ fontSize: "1.3rem", color: "cyan" }}>
                Agent Points: {moneyFormat(user.points || 0)}
              </Text>
            }
            onChange={(key) => {
              setTabKey(key);
              getDataList(1, pagin.per_page, filter, key);
            }}
            items={[
              {
                key: "not_finish",
                label: "Not Finish",
              },
              {
                key: "finish",
                label: "Finish",
              },
            ]}
          />
        </Col>

        <Col span={24}>
          <Row align="middle">
            <Col>
              <Text>Code : &nbsp;</Text>
            </Col>

            <Col>
              <Input
                size={user.ui_size}
                style={{ width: "150px" }}
                value={filter.user_code}
                placeholder="Search by Code"
                onChange={(e) =>
                  setFilter({ ...filter, user_code: e.target.value })
                }
              />
            </Col>

            <Col style={{ marginLeft: "20px" }}>
              <Text>Transaction Type : &nbsp;</Text>
            </Col>
            <Col>
              <Select
                size={user.ui_size}
                style={{ width: "150px" }}
                placeholder="Select Type"
                value={filter.type || undefined}
                onChange={(value) => setFilter({ ...filter, type: value })}
                allowClear={false}
              >
                <Option value="DEPOSIT">Deposit</Option>
                <Option value="WITHDRAW">Withdraw</Option>
              </Select>
            </Col>

            <Col style={{ marginLeft: "20px" }}>
              <Text>Date : &nbsp;</Text>
            </Col>
            <Col>
              <DatePicker.RangePicker
                size={user.ui_size}
                style={{ width: "300px" }}
                format={"YYYY-MM-DD"}
                value={[
                  filter.start_date
                    ? dayjs(filter.start_date, "YYYY-MM-DD")
                    : null,
                  filter.end_date ? dayjs(filter.end_date, "YYYY-MM-DD") : null,
                ]}
                onChange={(dates) => {
                  setFilter({
                    ...filter,
                    start_date: dates?.[0]?.format("YYYY-MM-DD") || "",
                    end_date: dates?.[1]?.format("YYYY-MM-DD") || "",
                  });
                }}
              />
            </Col>

            <Col style={{ marginLeft: "20px" }}>
              <Space>
                <Button
                  size={user.ui_size}
                  type="primary"
                  onClick={() => {
                    getDataList(1, pagin.per_page);
                  }}
                >
                  Search
                </Button>
                <Button
                  size={user.ui_size}
                  type="primary"
                  onClick={() => clearFilter()}
                >
                  Clear
                </Button>
              </Space>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table
            size={user.ui_size}
            loading={loading}
            columns={tabKey === "not_finish" ? columns : finishColumn}
            dataSource={list}
            rowKey={(e) => e.id}
            pagination={{
              total: pagin.total,
              current: pagin.page_number,
              pageSize: pagin.per_page,
              showSizeChanger: true,
              pageSizeOptions: [10, 20, 50],
              onChange: (pageNumber, perPage) => {
                getDataList(pageNumber, perPage);
              },
              onShowSizeChange: (current, size) => {
                getDataList(1, size);
              },
            }}
            expandable={{
              expandedRowRender: (record) => (
                <ExpandableContent record={record} />
              ),
            }}
          />
        </Col>
      </Row>

      <Drawer
        open={showForm}
        title={confirmData ? "Accept Form" : "Reject Form"}
        width={560}
        destroyOnClose
        onClose={() => closeDrawer()}
      >
        <ConfirmForm
          closeDrawer={closeDrawer}
          detail={{ id: detail.user_id }}
          confirmData={confirmData}
          rejectData={rejectData}
          getDataList={() => getDataList(pagin.page_number, pagin.per_page)}
        />
      </Drawer>

      <Drawer
        open={detailForm}
        title="User Detail"
        width={1600}
        destroyOnClose
        styles={{
          body: { margin: 0, padding: 0 },
          header: { borderBottom: "0px" },
        }}
        onClose={() => setDetailForm(false)}
      >
        {selectedUser && (
          <UserDetail
            closeDrawer={() => setDetailForm(false)}
            detail={selectedUser}
          />
        )}
      </Drawer>
    </>
  );
}
